import { LIST_STATES_UF, TYPE_BIKE } from './constants';

export const getUrlOffers = (vehicleType: number, brand: string, model: string, year: string, uf: string) => {
    const vehicleTypeName = vehicleType === TYPE_BIKE ? 'motos' : 'carros';

    const state = LIST_STATES_UF.find((state) => state.value.toLowerCase() === uf.toLowerCase());

    return `${process.env.NEXT_PUBLIC_API_BASE_URL}/${vehicleTypeName}/${uf}/estoque/${brand}/${model}/de.${year}/ate.${year}?tipoveiculo=${vehicleTypeName}&estadocidade=${state!.label}&marca1=${brand}&modelo1=${model}&anode=${year}&anoate=${year}&page=1&displayPerPage=7`;
};
